export const PAGINATION_INITIAL_STATE = {
  page: null,
  next_page: null,
  prev_page: null,
  total_pages: null,
  total_results: null
}

export const QUESTION_TYPES = {
  PARAGRAPH: 'Paragraph',
  DROPDOWN: 'Dropdown',
  CHECKBOX: 'Checkbox',
  RADIO: 'Radio'
}

export const QUESTION_ACTIONS = {
  ADD_QUESTION: 'ADD_QUESTION',
  UPDATE_QUESTION: 'UPDATE_QUESTION',
  DELETE_QUESTION: 'DELETE_QUESTION',
  REORDER_QUESTIONS: 'REORDER_QUESTIONS',
  RESET_QUESTIONS: 'RESET_QUESTIONS',
  FETCH_QUESTIONNAIRE_TEMPLATES: 'FETCH_QUESTIONNAIRE_TEMPLATES',
  FETCH_QUESTIONNAIRE_TEMPLATES_SUCCESS: 'FETCH_QUESTIONNAIRE_TEMPLATES_SUCCESS',
  FETCH_QUESTIONNAIRE_TEMPLATES_FAILURE: 'FETCH_QUESTIONNAIRE_TEMPLATES_FAILURE'
}
